<template>
  <div class="console-card-wrapper">
    <router-link
      class="card-wrapper"
      :to="`/studio/view?dashboard_id=${dashboard.id}`"
      @click="trackClicks(dashboard.id)"
      @contextmenu.prevent="showOptions($event)"
    >
      <div class="dashboard-view smooth-shadow">
        <label class="city">{{ dashboard.city }}</label>

        <h3 class="title">{{ dashboard.name }}</h3>
        <p class="description">{{ dashboard.description }}</p>
        <div class="flex-expand"></div>
        <div class="flex-row-align-center mar-bottom-5">
          <p
            class="chit"
            v-for="(metric, index) in dashboard.getMetricNames().slice(0, 2)"
            :key="index"
          >
            {{ metric }}
          </p>
        </div>
        <div class="meta-area">
          <p>
            Created by
            <span class="fc-primary">{{ dashboard.created_by }}</span>
          </p>
          <p>{{ dashboard.created_at }}</p>
        </div>
      </div>
    </router-link>
    <ConsoleOptions
      :options="contextOptions"
      @clickEdit="$emit('edit')"
      @clickDuplicate="
        $emit('duplicate', { id: dashboard.id, name: dashboard.name })
      "
      @clickDelete="$emit('delete', { id: dashboard.id, name: dashboard.name })"
      @clickShare="$emit('share', { id: dashboard.id, name: dashboard.name })"
    />
  </div>
</template>

<script>
import { trackConsoleClicks } from "@/lib/analytics";
import ConsoleOptions from "@/components/console/views/ConsoleOptions";
import notify from "@/lib/notifications";

export default {
  components: {
    ConsoleOptions,
  },
  props: {
    dashboard: Object,
  },
  data() {
    return {
      contextOptions: [
        {
          name: "Edit",
          icon: "edit",
          event: "clickEdit",
        },
        {
          name: "Duplicate",
          icon: "file_copy",
          event: "clickDuplicate",
        },
        {
          name: "Delete",
          icon: "delete",
          event: "clickDelete",
        },
        {
          name: "Share",
          icon: "share",
          event: "clickShare",
        },
      ],
    };
  },
  methods: {
    trackClicks(dashboard_id) {
      trackConsoleClicks({ dashboard_id });
    },
    copyDashboardLink() {
      this.$clipboard(
        `${window.location.origin}/studio?dashboard_id=${this.dashboard.id}`
      );
      notify.success("Link copied to clipboard");
    },
  },
};
</script>

<style lang="scss" scoped>
.card-wrapper {
  height: 100%;
}

.console-card-wrapper {
  position: relative;
}
.dashboard-view {
  background: var(--color-secondary);
  display: flex;
  flex-direction: column;
  padding: 25px;
  border-radius: 5px;
  position: relative;
  min-width: 350px;
  height: 160px;
  transition: 0.2s all ease-in-out;
  border-top: 3px solid transparent;

  &:hover {
    box-shadow: 0 10px 15px #453d4d33;
    border-top: 3px solid var(--color-primary);
    //transform: scale(1.01);
  }

  &:active {
    transform: scale(0.98);
  }

  .more-icon {
    position: absolute;
    top: 15px;
    right: 0;

    &.placeholder {
      display: none;
    }
  }
  .city {
    color: var(--color-primary);
    pointer-events: none;

    &.placeholder {
      width: 100px;
      background: var(--border-color);
      padding: 10px;
      border-radius: 50px;
    }
  }

  .title {
    font-weight: bold;
    margin-top: 5px;

    &:hover {
      color: var(--color-primary);
    }

    &.placeholder {
      width: 200px;
      background: var(--font-color-unselected);
      padding: 10px;
      border-radius: 50px;
    }
  }

  .description {
    margin: 7px 0;
    height: 50px;
    opacity: 0.7;

    &.placeholder {
      background: var(--border-color);
      padding: 10px;
      border-radius: 5px;
    }
  }

  .chit {
    padding: 2px 10px;
    margin: 2px 5px 0px 0px;
    background: var(--color-primary-light);
    color: var(--color-primary);
    font-size: 0.8em;
    border-radius: 3px;
  }

  .meta-area {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    p {
      margin: 0;
      color: var(--font-color);
    }

    &.placeholder p {
      width: 100px;
      background: var(--font-color-unselected);
      padding: 7px;
      border-radius: 50px;
    }
  }
}
</style>
